// extracted by mini-css-extract-plugin
export default {"form":"DistribuidorClientes_form__LXg5e","trBody":"DistribuidorClientes_trBody__vDV2e","areaBtn":"DistribuidorClientes_areaBtn__Q8yA-","btn":"DistribuidorClientes_btn__QSmGI"};